module.exports = __webpack_public_path__ + "img/ic-gps-assigned.353625b1.svg";